<form [formGroup]="datiGeneraliForm" (ngSubmit)="save();">
  <app-dati-generali-fascicolo-common [request]="request" [fascicolo]="fascicolo" [inserimento]="inserimento" [datiGeneraliForm]="datiGeneraliForm" (changedFondoRischiState)="changedFondoRischiState()"></app-dati-generali-fascicolo-common>                                                                        
  <app-protocol-fascicolo-form [fascicolo]="fascicolo" (protocolDataChange)="onDataProtocol($event)" [dataView]="protocollo" /> 
  <div class="row">
    <div comboModInput class="col-sm-6" [labelInput]="'Grado'"
         formControlName="grado" [labelOption]="'descrizione'"
         [objectReference]="request.fascicolo.grado" [location]="'mesi'"
         (onReturn)="request.fascicolo.grado = $event"
         [optionsCombo] ="gradi"></div>

    <div comboModInput class="col-sm-6" [labelInput]="'Tipo Esecuzione'"
         formControlName="tipoEsecuzione" [labelOption]="'descrizione'"
         [objectReference]="request.fascicolo.tipoEsecuzione"
         (onReturn)="request.fascicolo.tipoEsecuzione = $event"
         [optionsCombo] ="tipiEsecuzione"></div>
  </div>

  <div class="row">
    <div textInput [control]="datiGeneraliForm.controls['nruolo']"
         class="col-sm-6" [labelInput]="'N&deg; ruolo'"
         formControlName="nruolo"
         [maxLength]="'255'"
         [(ngModel)]="request.fascicolo.numeroRuolo"></div>

    <div naturalNumberInput [control]="datiGeneraliForm.controls['annoRuolo']"
         class="col-sm-6" [labelInput]="'Anno ruolo'" [maxLength]="'4'"
         formControlName="annoRuolo" [checkFormat]="true"
         [(ngModel)]="request.fascicolo.annoRuolo"></div>
  </div>
  <div class="row">
    <div comboModInput class="col-sm-3" [control]="datiGeneraliForm.controls['autoritaGiudiziaria']"
         [(ngModel)]="request.fascicolo.autoritaGiudiziaria"
         [labelInput]="'Autorit&agrave; giudiziaria'" [mandatory]='true'
         formControlName="autoritaGiudiziaria" [labelOption]="'descrizione'"
         [optionsCombo] ="autoritaGiudiziarie"
         (change)="loadCittaPerAutoritaGiudiziaria($event);"
         [objectReference]="request.fascicolo.autoritaGiudiziaria"
         (onReturn)="request.fascicolo.autoritaGiudiziaria = $event"></div>

    <div comboModInput class="col-sm-3" [control]="datiGeneraliForm.controls['autoritaGiudiziariaCitta']"
         [labelInput]="'Sede autorit&agrave;'"
         [submitPending]="!request.fascicolo.autoritaGiudiziaria"  [mandatory]='true'
         [(ngModel)]="request.fascicolo.autoritaGiudiziariaCitta"
         formControlName="autoritaGiudiziariaCitta"
         [optionsCombo] ="cittaPerAutoritaGiudiziaria"
         [objectReference]="request.fascicolo.autoritaGiudiziariaCitta"
         (onReturn)="request.fascicolo.autoritaGiudiziariaCitta = $event"></div>

    <div textInput [control]="datiGeneraliForm.controls['sezione']"
         class="col-sm-3" [labelInput]="'Sezione'" formControlName="sezione"
         [(ngModel)]="request.fascicolo.sezione"></div>

    <div textInput [control]="datiGeneraliForm.controls['giudice']"
         class="col-sm-3" [labelInput]="'Giudice'" formControlName="giudice"
         [(ngModel)]="request.fascicolo.giudice"></div>
  </div>
  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12"
         [labelInput]="'Note'" formControlName="note"
         [(ngModel)]="request.fascicolo.note"></div>
  </div>

  <div>
    <h3 class="title1level">Campi personalizzati</h3>
        <app-fascicolo-metadata-form *ngIf="!fascicolo.id && fascicolo.tipoFascicolo.id"
          [tipoFascicolo]="fascicolo.tipoFascicolo.id"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
        <app-fascicolo-metadata-form *ngIf="fascicolo.id && fascicolo.tipoFascicolo.id"
          [fascicolo]="request.fascicolo"
          (metadataListChange)="onRetrieve($event)"
          (formChange)="isFormMetadataValid($event)">
        </app-fascicolo-metadata-form>
  </div>

  <div class="row">
    <p class="mandatory col-sm-12">
      <em>* Campi obbligatori</em>
    </p>
  </div>

  <div
    *ngIf="checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi"
    class="row">
    <div class="col-sm-12 form-group">
      <p *ngIf="checkFondoRischiRemoved" confermaCambioFr #confermaCambioFrModifica (onReturn)="notifyConferma($event)"></p>
    </div>
  </div>

  <div [ngClass]="minervaWizard ? 'wizard-buttons' : ''" class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" class="btn btn-outline-secondary btn-block"
              (click)="resetForm.emit()">Reset</button>
    </p>
    <p submitButton	class="col-sm-3 col-xs-6 col-sm-offset-6"
       [labelButton]="minervaWizard ? 'Prosegui' : 'Salva'" [disabled]=" (checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi ? !confermaFrChangeChecked : false) ||
														( (changeFondoRischi && !request.fascicolo.dataVariazioneFondoRischi) && ( !inserimento ) && ( !wizard ) ) ||
														!datiGeneraliForm.valid || !metadataFormValid"></p>
  </div>
</form>
